import type { SVGProps } from 'react';

export enum IconTypes {
  'arrow45' = 'arrow45',
  'arrowNext' = 'arrowNext',
  'arrowPrevious' = 'arrowPrevious',
  'arrowRight' = 'arrowRight',
  'bill' = 'bill',
  'communal' = 'communal',
  'cross' = 'cross',
  'doc' = 'doc',
  'education' = 'education',
  'eye' = 'eye',
  'eyeClosed' = 'eyeClosed',
  'fines' = 'fines',
  'internet' = 'internet',
  'linkIcon' = 'linkIcon',
  'logo' = 'logo',
  'logoSK' = 'logoSK',
  'mapMark' = 'mapMark',
  'mapMarkExcursion' = 'mapMarkExcursion',
  'menu' = 'menu',
  'mobile' = 'mobile',
  'monitor' = 'monitor',
  'resource' = 'resource',
  'settlement' = 'settlement',
  'taxes' = 'taxes',
  'todo' = 'todo',
}

export interface IIconProps extends Omit<SVGProps<SVGSVGElement>, 'style'> {
  icon: IconTypes;
  size?: 16 | 24 | number;
  color?: string;
}
